import './App.css';
import React from "react";
import { useLocalizedStrings } from "./Localization";
import { LocalizationProvider } from './Localization';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import TopBar from "./components/TopBar"
import Hello from './components/Hello';
import About from './components/About';
import Hero from './components/Hero.jsx';
import Skills from './components/Skills.jsx';
import Projects from './components/Projects.jsx';
import Contact from './components/Contact.jsx';
import Footer from './components/Footer.jsx';
import Personality from './components/Personalities.jsx';
import ProjectDrone from "./components/ProjectDrone";
import ProjectSegmentation from "./components/ProjectSegmentation";
import ChatBot from "./components/ProjectChatBot.jsx";
function App() {

  const strings = useLocalizedStrings();

  return (
    
      <LocalizationProvider>
        <Router>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/" element={<Projects />} />
            <Route path="/project/drone" element={<ProjectDrone />} />
            <Route path="/project/segmentation" element={<ProjectSegmentation />} />
            <Route path='project/chatbot' element={<ChatBot />} />
          </Routes> 
        </Router>
      </LocalizationProvider>
    
  )
}
const HomePage = () => (
  <>
    <div className='pb-20 bg-[#B7B1F2]'>
      <TopBar />
      <Hello />
      <Hero />
      <About />
      <Skills />
      <Projects />
      <Personality />
    </div>
    <div className='border-t-8 border-black bg-[#FFDCCC]' >
      <Contact />
      <Footer />
    </div>
  </>
);
const ProjectInfoPage = () => (
  <>
    <div className='pb-20 bg-[#B7B1F2]'>
      <TopBar />
    
    </div>
    <div className='border-t-8 border-black bg-[#FFDCCC]' >
      <Contact />
      <Footer />
    </div>
  </>
);
export default App;
